'use strict';

partnershipDetail.$inject = ["ProductOverviewItem", "Contract"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnershipDetail = partnershipDetail;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnershipDetail(ProductOverviewItem, Contract) {
    var clazz = function PartnershipDetail() {
        var defaults = {
            id: 0,
            partner: null,
            featuredImage: null,
            title: null,
            leading: null,
            content: null,
            summaryList: null,
            summary: null,
            gallery: null,
            links: null,
            callToActionContent: null,
            callToActionLinks: null,
            sellerContactPersons: null,
            type: '',
            typeName: '',
            contracts: null,
            discounts: null,
            hasNoLinkedContracts: null,
            category: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource, shopProductItems) {
        var partnership = new clazz();
        partnership.id = resource.id;
        partnership.featuredImage = resource.featuredImage;
        partnership.partner = resource.partner;
        partnership.title = resource.title;
        partnership.leading = resource.leading;
        partnership.content = resource.content;
        partnership.summaryList = resource.summaryList;
        partnership.summary = resource.summary;
        partnership.links = resource.links;
        partnership.gallery = resource.gallery;
        partnership.callToActionContent = resource.callToActionContent;
        partnership.callToActionLinks = resource.callToActionLinks;
        partnership.sellerContactPersons = resource.sellerContactPersons;
        partnership.type = resource.type;
        partnership.typeName = resource.typeName;
        partnership.contracts = resource.contracts.map(function (c) {
            return Contract.create(c);
        });
        partnership.hasNoLinkedContracts = resource.hasNoLinkedContracts;
        partnership.discounts = resource.discounts.map(function (d) {
            return ProductOverviewItem.getClass().create(d, shopProductItems);
        });
        partnership.category = resource.category;
        return partnership;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/partnershipDetail.js
// module id = 770
// module chunks = 0